import IMask from 'imask'

// Controls what value is emitted to onChange when an input has a textMask.
//   'raw'       — emit only the placeholder characters the user typed
//                 (e.g. "5551234567" for a phone mask).
//   'formatted' — emit the full masked string, including literal characters
//                 (e.g. "+1 (555) 123-4567").
export type MaskStoredAs = 'raw' | 'formatted'

// Converts the legacy text-input-mask format ("+1 ([000]) [000]-[0000]") to
// an iMask pattern string ("+1 (000) 000-0000"). Characters inside [...] are
// placeholder chars; everything outside is a literal.
//   0  → required digit
//   9  → optional digit  (via IMASK_DEFINITIONS)
//   A  → required letter (mapped to iMask 'a')
//   a  → optional letter (via IMASK_DEFINITIONS, mapped to iMask 'A')
//   _  → any char
export function parseMaskToImask(textMask: string): string {
  let result = ''
  let i = 0
  while (i < textMask.length) {
    if (textMask[i] === '[') {
      const end = textMask.indexOf(']', i)
      if (end === -1) break
      const group = textMask.slice(i + 1, end)
      for (const ch of group) {
        switch (ch) {
          case '0': result += '0'; break
          case '9': result += '9'; break
          case 'A': result += 'a'; break
          case 'a': result += 'A'; break
          case '_': result += '*'; break
        }
      }
      i = end + 1
    } else {
      result += textMask[i]
      i++
    }
  }
  return result
}

export const IMASK_DEFINITIONS: IMask.MaskedPatternOptions['definitions'] = {
  '9': { mask: /[0-9]/, optional: true },
  'A': { mask: /[a-zA-Z]/, optional: true },
}
